import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {RequestBody} from "../../interfaces/admin.interface";
import {LoggingService} from "../log.service";
import {RestfulService} from "../restful.service";
import {BaseService, EndPoint, ListService} from "../../classes/baseService";
import {ItemCrudInfo, ItemData, ItemRequestBody} from "../../interfaces/item.interface";

@Injectable({
    providedIn: 'root'
})
export class ItemCrudService extends BaseService<ItemCrudInfo, ItemData> implements ListService<ItemRequestBody> {

    public static endPoint = new EndPoint('product', true)

    constructor(
        logger: LoggingService,
        restful: RestfulService,
    ) {
        super(logger, restful)
        this.endPoint = ItemCrudService.endPoint
    }

    protected override getDefaultDto(): ItemCrudInfo {
        return new ItemCrudInfo();
    }


    list(reqBody: RequestBody) {
        return this.listImpl(ItemCrudService.endPoint.paths.find, reqBody)
    }

    override getRecord(id: number): Observable<any> {
        return this.getRecordImpl(id, ItemCrudService.endPoint.paths.findInfo);
    }

    save(reqBody: ItemData, id?: number) {
        this.saveImpl(reqBody, id != null ? ItemCrudService.endPoint.paths.update : ItemCrudService.endPoint.paths.create, id)
    }

}

